import * as moment from "moment";

import { ClientScheduleType } from "utils/transformApiSchedule";

export default function nthWeekdaySampleDates(
  schedule: Pick<ClientScheduleType, "dayNumber" | "weekNumber">,
): Date[] {
  const { dayNumber, weekNumber } = schedule;

  if (!dayNumber || !weekNumber) return [];

  const startOfMonthWeek = moment()
    .startOf("month")
    .week();

  const newWeek = startOfMonthWeek + parseInt(weekNumber, 10);

  const date = moment()
    .day(parseInt(dayNumber, 10))
    .week(newWeek)
    .toDate();

  return [date];
}
